import React from 'react';
import "./header.css";
import { getBrandLogoUrl } from '../../../utils';

function Header( { backgroundColor } ) {
    const logoUrl = getBrandLogoUrl('dark');
    
    return (
      <div className={`uc-navbar-wrapper`} style={{backgroundColor: '#010101'}}>
      <nav className="navbar navbar-expand-md uc-navbar">
        <a href="https://www.urbancompany.com/" >
          <div className="logo-box">
            <img id="uc-logo" src={logoUrl} />
          </div> 
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
        >
          <i className="fas fa-bars"></i>
        </button>

        <div className="openings" id="navbarSupportedContent">
          <div className="button">
            <a href="https://urbanclap-engg.github.io/marc/#/pages/overview" className="button-open-position" target="_blank">
              Documentation
            </a>
          </div>
          <div className="button" style={{marginLeft:10}}>
            <a href="https://github.com/urbanclap-engg/marc" className="button-open-position" target="_blank">
              Source Code
            </a>
          </div>
          <div className="button" style={{marginLeft:10}} >
            <a href="https://tech.urbancompany.com/ucs-amazing-story-of-microservices-fe20b6b8d616" className="button-open-position" target="_blank">
              Blog
            </a>
          </div>
          <div className="button" style={{marginLeft:10}} >
            <a href="https://www.npmjs.com/package/@uc-engg/marc" className="button-open-position" target="_blank">
              Npm
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
